import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { MachineStateIconContainer } from '../MachineStatesIcon.elements';
import { useBuSettings } from 'common/pages/fleetV2/providers';
import { dsiApi } from 'common/pages/fleetV2/machine/dsi/api';
import { useFleetRouter } from 'common/pages/fleetV2/hooks/useFleetRouter';
import { useTranslation } from 'react-i18next';


/****
 * possible machine states for DSI:
 * - Running
 * - Not Running
 * - Connected
 * - no product
 * - offline
 * - not connected
 */
const useMachineState = () => {
  const { colors, Icons } = useBuSettings();
  const [{ id: machineId }] = useFleetRouter();
  const { t} = useTranslation(['mh']);
  const currentData = useSelector((state) => dsiApi.endpoints.getMachineStatus.select({machineId})(state))
  const currentstate = currentData?.data?.machineState ? currentData?.data?.machineState : undefined

  const label = currentstate ? (currentstate as unknown as string).toString().toLowerCase() : 'unknown'
  const state = currentstate ? currentstate : t(`machine is offline`)

  let hasMessage: string | undefined = state

  if (!state || state === 'Running' || state === "Connected" || state === "No Product") hasMessage = undefined
  else if (state) hasMessage = t(state) as string
  
  const messagewindowEl = document?.querySelector('.overlay-message') as HTMLElement;
  const titleEl = messagewindowEl?.querySelector('[data-id="title"]') as HTMLElement;
  if (titleEl) {
    if (hasMessage) {
      titleEl.innerText = hasMessage
      messagewindowEl.style.display = 'flex'
    } else {
        messagewindowEl.style.display = 'none'
    }
  }

  return {
    state,
    color: colors?.[label],
    Icon: Icons?.[label]
  };
};

export const DSIMachineStateIcon = (): JSX.Element => {

  const { color, state, Icon } = useMachineState();

  if(!state) return <></>

  return (
    <div className="machine-info-bar__item machine-state">
      Machine State:
      <MachineStateIconContainer className="machine-state-icon" {...{ color }}>
        <span className="label">{state}</span> {Icon}
      </MachineStateIconContainer>
    </div>
  );
};
